import Vue from 'vue'
import { GetterTree, MutationTree } from "vuex"

import { getResource } from "~/utils/store"
import { RootState } from "~/store/store.types"

import { AvailabilityRatesState, AvailabilityRateResource } from "./availability-rates.types"

export const state = (): AvailabilityRatesState => ({
  data: {},
  filters: {}
})

export const getters: GetterTree<AvailabilityRatesState, RootState> = {
  resourceById(state, _, __, rootGetters) {
    return (id: string, included: string | string[] = []) =>
      getResource<AvailabilityRateResource>(state, id, rootGetters, included)
  },

  resources(state, getters) {
    return (included: string | string[] = []) => Object.keys(state.data).map(key =>
      getters.resourceById(key, included))
  },

  filteredAvailabilityRates(state, getters) {
    return (selectedAvailabilityRates: AvailabilityRateResource[], included: string | string[] = []) => {
      const resources = getters.resources(included)
      // Filter only resources 
      // that match ids with
      // the specifed availabilityRates
      return resources.filter(
        (availabilityRate: AvailabilityRateResource) => selectedAvailabilityRates.some(
          (rate: AvailabilityRateResource) => rate.id === availabilityRate.id
        ))
    }
  }
}

export const mutations: MutationTree<AvailabilityRatesState> = {
  SET_AVAILABILITY_RATE (state, availabilityRate: AvailabilityRateResource) {
    const { id } = availabilityRate

    Vue.set(state.data, id, availabilityRate)
  }
}
